import { Suspense, lazy } from 'react';
// components
import LoadingScreen from 'components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));

// Home
export const HomePage = Loadable(lazy(() => import('pages/Home')));
// Templates
export const TemplateListPage = Loadable(lazy(() => import('pages/requests/Templates-List')));
export const TemplateDetailPage = Loadable(lazy(() => import('pages/requests/Template-Request-Detail')));
export const UpdateDetailPage = Loadable(lazy(() => import('pages/requests/Update-Request-Detail')));
export const CvDetailPage = Loadable(lazy(() => import('pages/requests/Cv-Request-Detail')));
export const TemplateNewRequest = Loadable(lazy(() => import('pages/requests/NewRequest')));
export const EditRequets = Loadable(lazy(() => import('pages/requests/Edits')));
// sliders
export const SlidersListPage = Loadable(lazy(() => import('pages/Sliders/list')));
export const CreateSliderPage = Loadable(lazy(() => import('pages/Sliders/create')));
export const SliderDetailPage = Loadable(lazy(() => import('pages/Sliders/detail')));
export const SliderEditPage = Loadable(lazy(() => import('pages/Sliders/edit')));
// banners
export const CreateBannerPage = Loadable(lazy(() => import('pages/banners/create')));
export const BannerDetailPage = Loadable(lazy(() => import('pages/banners/detail')));
export const EditBannerPage = Loadable(lazy(() => import('pages/banners/edit')));
export const BannersListPage = Loadable(lazy(() => import('pages/banners/list')));
// features
export const CreateFeaturePage = Loadable(lazy(() => import('pages/feature/FeatureCreate')));
export const FeatureDetailPage = Loadable(lazy(() => import('pages/feature/FeatureDetail')));
export const EditFeaturePage = Loadable(lazy(() => import('pages/feature/FeatureEdit')));
export const FeaturesListPage = Loadable(lazy(() => import('pages/feature/FeatureList')));
// tag
export const CreateTagPage = Loadable(lazy(() => import('pages/tag/CreateTag')));
export const TagDetailPage = Loadable(lazy(() => import('pages/tag/TagDetail')));
export const EditTagPage = Loadable(lazy(() => import('pages/tag/EditTag')));
export const TagsListPage = Loadable(lazy(() => import('pages/tag/TagList')));
// gallery
export const GalleryPage = Loadable(lazy(() => import('pages/Gallery')));
// Global
export const NotFoundPage = Loadable(lazy(() => import('pages/Page404')));

export const LogOutPage = Loadable(lazy(() => import('pages/logout')));

// WEBINAR
export const WebinarAll = Loadable(lazy(() => import('pages/webinar/all')));
export const OnBoardWebinars = Loadable(lazy(() => import('pages/webinar/onboard')));
export const WebinarNewRequests = Loadable(lazy(() => import('pages/webinar/newRequests')));
export const WebinarConductor = Loadable(lazy(() => import('pages/webinar/conductor')));
export const WebinarRequestDetails = Loadable(lazy(() => import('pages/webinar/detail')));

// recommendation

export const ListRecommendationConflict = Loadable(
  lazy(() => import('pages/recommendation/conflict/ListRecommendationConflict'))
);
export const CreateRecommendationConflict = Loadable(
  lazy(() => import('pages/recommendation/conflict/CreateRecommendationConflict'))
);
export const EditRecommendationConflict = Loadable(
  lazy(() => import('pages/recommendation/conflict/EditRecommendationConflict'))
);
export const ListRecommendationQuestion = Loadable(
  lazy(() => import('pages/recommendation/question/ListRecommendationQuestion'))
);
export const CreateRecommendationQuestion = Loadable(
  lazy(() => import('pages/recommendation/question/CreateRecommendationQuestion'))
);
export const EditRecommendationQuestion = Loadable(
  lazy(() => import('pages/recommendation/question/EditRecommendationQuestion'))
);
export const ListRecommendationTag = Loadable(lazy(() => import('pages/recommendation/tag/ListRecommendationTag')));
export const CreateRecommendationTag = Loadable(lazy(() => import('pages/recommendation/tag/CreateRecommendationTag')));
export const EditRecommendationTag = Loadable(lazy(() => import('pages/recommendation/tag/EditRecommendationTag')));

export const ListRecommendationRelation = Loadable(
  lazy(() => import('pages/recommendation/relation/ListRecommendationRelation'))
);
export const EditRecommendationRelation = Loadable(
  lazy(() => import('pages/recommendation/relation/EditRecommendationRelation'))
);
